import SingleNavigation from './class/SingleNavigation';
import BigBanner from './flexibles/BigBanner';
import Blog from './flexibles/Blog';
import Contact from './flexibles/Contact';
import ContactBrevo from './flexibles/ContactBrevo';
import EventRegistration from './flexibles/EventRegistration';
import Expertises from './flexibles/Expertises';
import Hook from './flexibles/Hook';
import Library from './flexibles/Library';
import Mainstay from './flexibles/Mainstay';
import PictoColumns from './flexibles/PictoColumns';
import Presentation from './flexibles/Presentation';
import Press from './flexibles/Press';
import Prestations from './flexibles/Prestations';
import SellsyForm from './flexibles/SellsyForm';
import SimpleText from './flexibles/SimpleText';
import SinglePost from './flexibles/SinglePost';
import TabAccordeon from './flexibles/TabAccordeon';
import Team from './flexibles/Team';
import Testimonies from './flexibles/Testimonies';
import TwoColumns from './flexibles/TwoColumns';

const SECTIONS = {
	mainstay: Mainstay,
	hook: Hook,
	blog: Blog,
	contact: Contact,
	library: Library,
	'big-banner': BigBanner,
	presentation: Presentation,
	prestations: Prestations,
	'two-columns': TwoColumns,
	simple: SimpleText,
	'picto-columns': PictoColumns,
	team: Team,
	expertises: Expertises,
	'single-navigation': SingleNavigation,
	'single.post-type-post': SinglePost,
	testimonies: Testimonies,
	press: Press,
	'event-registration': EventRegistration,
	'sellsy-form': SellsyForm,
	'contact-brevo': ContactBrevo,
	'tab-accordeon': TabAccordeon,
};

const FlexiblesInit = function () {
	for (let className in SECTIONS) {
		if (document.querySelector(`.${className}`)) {
			new SECTIONS[className](className);
		}
	}
};

export default FlexiblesInit;
